// XXX: Workaround for determining the code block is fenced or not.
export const isFencedCodeBlock = (codeContent) => {
    var _a;
    if (codeContent.value === '') {
        return true;
    }
    const indent = (_a = codeContent.position) === null || _a === void 0 ? void 0 : _a.indent;
    if (indent == null) {
        return false; // TODO
    }
    return indent.length >= codeContent.value.split('\n').length;
};
//# sourceMappingURL=utils.js.map